// Module
var code = "<div class=\"wtsim-child-map\" id=\"child-map-{{ID}}\"> <div class=\"wtsim-map\">{{&MAP}}</div> </div>";
// Exports
module.exports = code;